
<template>
  <config-code apiname="texture" idname="textureId" labelname="รหัสชนิดผ้า"></config-code>
</template>

<script>
import ConfigCode from "./ConfigCode.vue";
export default {
  components: {
    ConfigCode
  }
};
</script>

